import "react-datepicker/dist/react-datepicker.css";
import i18n from "../../../constants/i18n";
import { NOT_PENDING_REPORTS_LIMIT } from "../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getReportsStore from "../../../stores/reports-store";
import Et3Picker from "../../../core/et3-input/et3-picker";
import { MINIMUM_REPORTS_BY_TYPE_LIMIT } from "../../../constants/input-entries-constants";
import Et3TextInput from "../../../core/et3-input/et3-text-input";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { TEt3PickerSingleValue } from "../../../TypesNEW";

const ReportsLimitPicker = withLiteObserverAndTheme(() => {
  const status = getReportsStore().status.get().value;
  const pendingReports = status === "pending";
  const limitValue = getReportsStore().reportsByTypeLimit.get();

  return pendingReports ? (
    <Et3TextInput
      size="MEDIUM"
      withShadow={true}
      type={"text"}
      icon={faLock}
      label={i18n.get("LIMIT")}
      placeHolder={i18n.get("LIMIT")}
      value={MINIMUM_REPORTS_BY_TYPE_LIMIT}
      onChoose={() => {}}
      onBlur={() => {}}
      onEnter={() => {}}
      style={{}}
    />
  ) : (
    <Et3Picker
      label={i18n.get("LIMIT")}
      onChoose={(value: TEt3PickerSingleValue) => {
        return getReportsStore().setReportsByTypeLimit(value);
      }}
      value={limitValue}
      options={NOT_PENDING_REPORTS_LIMIT}
      style={{}}
      isMultiple={false}
      onEnter={() => {}}
      onClick={() => {}}
      containerStyle={{}}
    />
  );
});
export default ReportsLimitPicker;
